export default "__VITE_ASSET__D1hfw_3L__"